<template>
    <el-card>
      <template v-slot:header>
        <div class="clearfix">
          <span style="font-weight: bold;">
            <i class="el-icon-pie-chart" style="font-weight: bold; font-size: larger; margin-right: 5px;"></i>TAD Size
          </span>
        </div>
      </template>
      <div class="container">
        <div id="tad" style="width: 100%; height: 500px;"></div>
      </div>
    </el-card>
  </template>
  
<script>
export default {
  props: {
    species: {
      type: String,
      required: true
    },
    tissue: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      chartData: [],
      url: "http://183.175.59.4/devenhancer/", // 后端接口地址
    };
  },
  mounted() {
    this.handleAnalysis();
  },
  methods: {
    handleAnalysis() {
      // 发送请求获取后端数据
      const params = { Species: this.species, Tissue: this.tissue };
      this.$axios
        .get(this.url + "tad" + "/", { params })
        .then((response) => {
          // 对数据进行处理
          const data = response.data;
          if (data && Array.isArray(data) && data.length > 0) {
            const scatterData = data.map((item) => {
              const value = item.Size ? parseFloat(item.Size) : null; // 转换为浮点数
              return {
                value: value,
                name: item.Chr
              };
            }).filter(item => item.value !== null); // 过滤掉无效的数据

            // 统计不同的Chr类型
            const xAxisData = Array.from(new Set(scatterData.map(item => item.name)));

            // 将xAxisData按照指定的顺序进行排序
              xAxisData.sort((a, b) => {
                  // 自定义排序规则，chr1-23 排在前面，x 和 y 排在后面
                  if (a.startsWith("chr") && b.startsWith("chr")) {
                      return parseInt(a.substr(3)) - parseInt(b.substr(3));
                  } else if (a === "x") {
                      return 1;
                  } else if (b === "x") {
                      return -1;
                  } else if (a === "y") {
                      return 1;
                  } else if (b === "y") {
                      return -1;
                  }
              });

            // 根据value字段排序
            scatterData.sort((a, b) => a.value - b.value);

            // 绘制散点图
            const chart = this.$echarts.init(document.getElementById('tad'));
            chart.setOption({
              xAxis: {
                  type: 'category',
                  data: xAxisData, // 设置x轴的类别为Chr字段
                  axisLabel: {
                      interval: 0,// 设置刻度之间的间隔为0，表示所有刻度都显示
                      rotate: 45 // 将文字倾斜45度
                  }
              },
              yAxis: {
                  type: 'value',
                  name: 'bp',
                  nameTextStyle: {
                      fontSize: 15
                  },
                  min: Math.min(...scatterData.map(item => item.value)), // 设置y轴的最小值为所有Size中的最小值
                  splitNumber: 3, // 将y轴分成3个刻度
                  axisLabel: {
                      rotate: 45 // 将文字倾斜45度
                  },
                  axisLine: {
                  show: true // 显示y轴线
                  },
                  splitLine: {
                      show: true // 显示y轴的刻度线
                  }
              },
              series: [
                {
                  name: 'TAD',
                  type: 'scatter',
                  label: {
                    show: false,
                  },
                  emphasis: {
                    label: {
                      show: false,
                    }
                  },
                  labelLine: {
                    show: false
                  },
                  data: scatterData.map(item => [item.name, item.value]), // 将Chr作为x轴数据，将Size作为y轴数据
                  color: '#47A992' // 设置点的颜色为#47A992
                }
              ]
            });
          } else {
            this.$message.warning('No data found.');
          }
        })
        .catch((err) => {
          console.error(err);
          this.$message.error('Failed to fetch data.');
        });
    },
  }
};
</script>

<style scoped>
.custom-button1 {
    float: right;
    background-color: #2C3E50;
    border: 1px solid #2C3E50;
    color: #F1F7E7; /* 设置文字颜色为白色，以提高对比度 */
}
.custom-button2 {
    float: right;
    background-color: #2C3E50;
    border: 1px solid #2C3E50;
    color: #F1F7E7; /* 设置文字颜色为白色，以提高对比度 */
    margin-right: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/TAD/Tadsize.vue